export const MDM_POLICIES = {
  TITLE: 'Políticas de dispositivos',
  SUBTITLE: 'Configura las políticas de dispositivos para tu organización',
  NEW_POLICY: 'Nueva política',
  TABS: {
    GENERAL: 'General',
    CIS: 'CIS Benchmark',
    LIBRARY: 'Biblioteca de Qalea',
    ORGANIZATION: 'Organización',
    HISTORY: 'Historial de despliegues',
  },
  SECTIONS: {
    OS_UPDATES: 'Actualizaciones de SO',
    DISK_ENCRYPTION: 'Cifrado de disco',
  },
  DISK_ENCRYPTION: {
    ENABLE: 'Habilitar Cifrado de Disco',
    HOST_STATUS: 'Estado del host',
    MACOS: 'macOS',
    WINDOWS: 'Windows',
    LINUX: 'Linux',
    TOTAL: 'Total',
    LOADING: 'Sincronizando con los hosts (puede tardar unos minutos)...',
    STATUS: {
      VERIFIED: 'Verificado',
      VERIFYING: 'Verificando',
      ACTION_REQUIRED: 'Acción requerida',
      ENFORCING: 'Aplicando',
      FAILED: 'Fallido',
      REMOVING_ENFORCEMENT: 'Eliminando',
    },
  },
  OS_UPDATES: {
    TITLE: 'Actualizaciones de SO',
    LAPTOPS: 'Portátiles',
    PHONES: 'Móviles',
    CONFIRM: {
      TITLE: (platform: string) => `¿Forzar la actualización de ${platform}?`,
      ACTION: 'Forzar actualización',
      NOTE: 'Ten en cuenta que los usuarios no podrán omitir ni aplazar la actualización.',
      UPDATE: 'Actualización',
      DEADLINE: 'Fecha límite',
      FORCED_RESTART: 'Reinicio forzado',
      NEWEST_VERSION: 'Versión más reciente compatible',
      AVAILABLE_UPDATES: 'Actualizaciones disponibles',
      DAYS_AFTER_RELEASE: (days: number) => `${days} ${days === 1 ? 'día' : 'días'} tras su publicación`,
      AT_DEADLINE: 'En la fecha límite',
      DAYS_AFTER_DEADLINE: (days: number) => `${days} ${days === 1 ? 'día' : 'días'} después de la fecha límite`,
    },
    MACOS: {
      TITLE: 'Actualizaciones de macOS',
      TARGET: 'Objetivo',
      TARGET_NONE: 'Sin actualizaciones forzadas',
      TARGET_SPECIFIC: 'Versión específica',
      TARGET_LATEST: 'Última versión',
      MINIMUM_VERSION: 'Versión mínima',
      DEADLINE: 'Fecha límite',
      DAYS_AFTER_RELEASE: 'días tras su publicación',
      UPDATE_NEW_HOSTS: 'Actualizar nuevos hosts automáticamente',
      REQUIRED: 'Obligatorio',
    },
    IOS: {
      TITLE: 'Actualizaciones de iOS',
      TARGET: 'Objetivo',
      TARGET_NONE: 'Sin actualizaciones forzadas',
      TARGET_SPECIFIC: 'Versión específica',
      TARGET_LATEST: 'Última versión',
      MINIMUM_VERSION: 'Versión mínima',
      DEADLINE: 'Fecha límite',
      DAYS_AFTER_RELEASE: 'días tras su publicación',
      REQUIRED: 'Obligatorio',
    },
    ANDROID: {
      TITLE: 'Actualizaciones de Android',
      UPDATE_POLICY: 'Política de actualización',
      TYPE_AUTOMATIC: 'Automática',
      TYPE_WINDOWED: 'Ventana diaria',
      TYPE_POSTPONE: 'Aplazar',
      INSTALL_WINDOW: 'Ventana de instalación',
      WINDOW_SEPARATOR: 'a',
    },
    WINDOWS: {
      TITLE: 'Actualizaciones de Windows',
      TARGET: 'Objetivo',
      TARGET_NONE: 'Sin actualizaciones forzadas',
      TARGET_LATEST: 'Últimas actualizaciones',
      DEADLINE_PREFIX: 'Una actualización debe instalarse antes de',
      GRACE_PERIOD_PREFIX: 'De lo contrario, un reinicio para instalar ocurrirá después de',
      DAYS: 'días',
      REQUIRED: 'Obligatorio',
    },
  },
}

export const MDM_POLICIES_MESSAGES = {
  UPDATED: 'Política actualizada correctamente',
  FAILED_TO_UPDATE: 'Error al actualizar la política',
  UNSUPPORTED_VERSION:
    'Apple no ofrece esta versión. Introduce una versión que Apple ofrezca actualmente o elige "Última versión".',
}

export const MDM_PROFILES = {
  SUMMARY: {
    HOSTS_TARGETED: 'hosts objetivo',
    VERIFIED: 'verificados',
    FAILED: 'fallidos',
  },
  TABLE: {
    COLUMNS: {
      NAME: 'Nombre',
      PLATFORM: 'Plataforma',
      STATUS: 'Estado',
      DATE: 'Fecha',
      HOSTS: 'Hosts',
    },
    NO_HOSTS: 'Sin hosts',
    HOSTS: 'hosts',
  },
  STATUS: {
    DEPLOYED: 'Desplegado',
    PENDING: 'Pendiente',
    FAILED: 'Fallido',
    VERIFIED: 'Desplegado',
    VERIFYING: 'Verificando',
    REMOVED: 'Eliminado',
  },
  ACTIONS: {
    DEPLOY: 'Desplegar',
    DEPLOY_PROFILE: 'Desplegar Política',
    CREATE_PROFILE: 'Crear Política',
    CANCEL: 'Cancelar',
    DONE: 'Listo',
    DEPLOYING: 'Desplegando...',
  },
  DRAWER: {
    TITLE: 'Detalles de la Política Personalizada',
    DEPLOYMENT_DETAILS: 'Detalles del Despliegue',
    REFRESH: 'Actualizar',
    PENDING_HINT: 'Los hosts lo aplican en su próxima conexión, lo que puede tardar un rato',
    SECTIONS: {
      DESCRIPTION: 'Descripción',
      PLATFORM: 'Plataforma',
      PROFILE_CONTENT: 'Contenido de la política',
      DEPLOYMENT_STATUS: 'Estado del Despliegue',
      HOST_BREAKDOWN: 'Desglose por Host',
    },
    EMPTY: {
      DESCRIPTION: 'Sin descripción',
      CONTENT: 'Sin contenido de la política',
    },
    HOST_BREAKDOWN: {
      HOST: 'Host',
      STATUS: 'Estado',
      DETAIL: 'Detalle',
      NO_HOSTS: 'Sin hosts desplegados',
    },
  },
  FORM: {
    TITLE: 'Nueva Política',
    FIELDS: {
      NAME: 'Nombre',
      NAME_PLACEHOLDER: 'Ingrese el nombre de la política',
      DESCRIPTION: 'Descripción',
      DESCRIPTION_PLACEHOLDER: 'Ingrese la descripción de la política',
      PLATFORM: 'Plataforma',
      CONTENT: 'Contenido de la Política',
      CONTENT_PLACEHOLDER: 'Ingrese el contenido XML/JSON de la política',
    },
  },
  DEPLOY_DIALOG: {
    DESCRIPTION: 'Seleccione grupos para desplegar esta política.',
    SUCCESS_DESCRIPTION: 'Política desplegada correctamente en todos los grupos seleccionados.',
    SEARCH_PLACEHOLDER: 'Buscar grupos...',
  },
  PLATFORMS: {
    MACOS: 'macOS',
    WINDOWS: 'Windows',
    IOS: 'iOS',
    ANDROID: 'Android',
  },
  MESSAGES: {
    PROFILE_CREATED: 'Perfil creado correctamente',
    PROFILE_CREATE_FAILED: 'Error al crear el perfil',
    PROFILE_DELETED: 'Perfil eliminado correctamente',
    PROFILE_DELETE_FAILED: 'Error al eliminar el perfil',
    NAME_CONFLICT: (name: string) => `Ya existe una política con el nombre "${name}", elige otro nombre.`,
    CONTENT_CONFLICT: 'Ya existe una política con el mismo contenido, modifícalo antes de guardar.',
  },
  DELETE_DIALOG: {
    TITLE: 'Eliminar Perfil',
    DESCRIPTION_PREFIX: '¿Estás seguro de que deseas eliminar',
    DESCRIPTION_SUFFIX: '?',
    HOSTS_PREFIX: 'La política se',
    HOSTS_EMPHASIS: 'quitará',
    HOSTS_SUFFIX: 'de todos sus hosts.',
    IRREVERSIBLE: 'Esta acción no se puede deshacer.',
    CANCEL: 'Cancelar',
    CONFIRM: 'Eliminar',
  },
}
